import React from 'react';
import { Label } from 'app/components/ui/label';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  helpText?: string;
  color?:
    | 'blue'
    | 'green'
    | 'orange'
    | 'purple'
    | 'red'
    | 'indigo'
    | 'emerald'
    | 'pink';
  required?: boolean;
  className?: string;
}

const colorClasses = {
  blue: 'from-blue-500 to-indigo-500',
  green: 'from-green-500 to-emerald-500',
  orange: 'from-orange-500 to-red-500',
  purple: 'from-purple-500 to-pink-500',
  red: 'from-red-500 to-pink-500',
  indigo: 'from-indigo-500 to-blue-500',
  emerald: 'from-emerald-500 to-green-500',
  pink: 'from-pink-500 to-purple-500',
};

export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  helpText,
  color = 'blue',
  required = false,
  className = '',
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label className="text-xs font-medium text-gray-800 dark:text-gray-200 flex items-center">
        <span
          className={`w-1.5 h-1.5 bg-gradient-to-r ${colorClasses[color]} rounded-full mr-2`}
        ></span>
        {label} {required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      {children}
      {helpText && (
        <p className="text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 px-2 py-1 rounded">
          {helpText}
        </p>
      )}
    </div>
  );
};

export default FormField;
